import { render, staticRenderFns } from "./BaseMessageBox.vue?vue&type=template&id=6f1682c8&"
import script from "./BaseMessageBox.vue?vue&type=script&lang=js&"
export * from "./BaseMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseMessageBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports